import { AUDIT_LOG_ERROR, AUDIT_LOG_REQUEST, AUDIT_LOG_SUCCESS } from "../../constants";
import { get } from 'lodash';

const initialState = {
  data: '',
  isLoading: false,
  error: '',
}


export default function (state = initialState, action) {
  switch (action.type) {
    case AUDIT_LOG_REQUEST:
      return { ...state, data: '', isLoading: action.isLoading, error: '' }
    case AUDIT_LOG_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: '' }
    case AUDIT_LOG_ERROR:
      return { ...state, data: '', isLoading: false, error: action.error }
    default:
      return state;
  }
}


export const getAuditLogsListTotalPages = (state) => get(state, 'auditLogs.data.totalPages');
export const getAuditLogsListTotalElements = (state) => get(state, 'auditLogs.data.totalElements');
export const getAuditLogsListResults = (state) => get(state, 'auditLogs.data.results');
export const getAuditLogsIsLoading = (state) => get(state, 'auditLogs.isLoading');

